import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

import "../styles/charts.scss";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const ChartsComponent = ({ value1, value2, label, unit, countryId }) => {
  const data = {
    labels: ["", ""],
    datasets: [
      {
        label: "",
        data:
          value1 == 0 ? [value2] : value2 == 0 ? [value1] : [value1, value2],
        backgroundColor: ["#007d8a", "#00a5b5"],
        borderRadius: 6,
        barThickness: 50,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    scales: {
      x: {
        grid: { display: false, drawBorder: false },
        ticks: {
          font: { size: 14 },
        },
        border: { display: false },
      },
      y: {
        display: false,
        grid: {
          drawBorder: false,
          color: (context) => {
            return "transparent";
          },
        },
      },
    },
  };

  const getValue = (value) => {
    var prefix = "";
    var suffix = "";
    if (countryId && [64, 183, 16, 161].includes(countryId)) {
      prefix = unit ? unit : "";
      value = value.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    } else {
      suffix = unit ? unit : "";
    }

    return `${prefix}${value}${suffix}`;
  };

  return (
    <div className="roi--container">
      <div className="roi--label">{label}</div>

      <div className="roi--values">
        {value1 !== 0 && (
          <h1 className="roi--value roi--value1">{getValue(value1)}</h1>
        )}
        {value2 !== 0 && (
          <h1 className="roi--value roi--value2">{getValue(value2)}</h1>
        )}
      </div>
      {(value1 !== 0 || value2 !== 0) && (
        <div className="roi--chart-wrapper">
          <Bar data={data} options={options} />
        </div>
      )}
    </div>
  );
};

export default ChartsComponent;
